"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var SoulModule = require('../SoulModule');

var uuid = require('uuid');

var queryString = require('query-string');
/**
* Send text, photos, locations
* @extends SoulModule
*/


var Chats =
/*#__PURE__*/
function (_SoulModule) {
  _inherits(Chats, _SoulModule);

  function Chats(params) {
    var _this;

    _classCallCheck(this, Chats);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Chats).call(this, params));
    _this.chatConnection = null;
    _this.apiUrls = params.apiUrls;
    _this.enrichChat = _this.enrichChat.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Chats, [{
    key: "connectChatsWS",

    /**
    * Returns webSocket connection to chat-service
    * @param {Boolean} isReconnect
    * Parameter passing as true if previous connect was failed or closed 
    * @return {WebSocket}
    * @soulsdk soul.chats.connectChatsWS
    * @example
    * soul.chats.connectChatsWS(true);
    */
    value: function connectChatsWS(isReconnect, userId) {
      var _this2 = this;

      this.eventEmitter.on('logout', function () {
        return _this2.closeChatConnectionWS();
      });

      if (isReconnect) {
        this.chatConnection = null;
      }

      if (!this.chatConnection) {
        this.chatConnection = null;
        var userAgent = this.storage.get('userAgent');
        var deviceId = uuid().toString();
        var authParam = "";

        if (this.storage.get('accessToken')) {
          authParam = "access-token=".concat(this.storage.get('accessToken'));
        }

        var wsUri = "".concat(this.chatWsUrl, "?").concat(authParam, "&user-agent=").concat(encodeURIComponent(userAgent), "&device-id=").concat(deviceId);
        this.chatConnection = new WebSocket(wsUri);
      }

      return this.chatConnection;
    }
    /**
    * Close webSocket connection to chat-service
    * @soulsdk soul.chats.closeChatConnectionWS
    * @example
    * soul.chats.closeChatConnectionWS();
    */

  }, {
    key: "closeChatConnectionWS",
    value: function closeChatConnectionWS() {
      if (this.chatConnection) {
        this.chatConnection.close();
        this.chatConnection = null;
      }

      return true;
    }
    /**
    * Returns webSocket connection to chat-service
    * @param {Object} msg
    * Message object
    * @param {String} msg.id
    * Unique for every combination of chat+user+message. See example
    * @param {Number} msg.t
    * Unixtimestamp in seconds of the time when the message was sent
    * @param {String} msg.u
    * Id of the user that sent this message
    * @param {String}[msg.m]
    * chat text message
    * @param {String} [msg.pa]
    * album name of the photo to send
    * @param {String} [msg.p]
    * ID of the photo to send (see). You must upload the photo before sending this message to chat channel
    * @param {String} [msg.lat]
    * latitude of the sent coordinates
    * @param {String} [msg.lng]
    * longitude of the sent coordinates
    * 
    * @param {String} channelName
    * Chat's ID 
    * @soulsdk soul.chats.chatSendMessageWS
    * @example
    * soul.chats.chatSendMessageWS('2451f278-c518-46db-ad31-97834a568c42', {
    *   message: {
    *    t: 1558099708.84,
    *    id: 'f16ac5fa739f',
    *    u: '5c362062ad8e7e67be1359ed',
    *    m: 'message text'
    *   }
    * })
    */

  }, {
    key: "chatSendMessageWS",
    value: function chatSendMessageWS(channelName, msg) {
      this.chatConnection.send(JSON.stringify(msg));
    }
  }, {
    key: "sendDeliveryConfirmationWS",
    value: function sendDeliveryConfirmationWS(_ref) {
      var channelName = _ref.channelName,
          _ref$message = _ref.message,
          id = _ref$message.id,
          u = _ref$message.u,
          myId = _ref.myId;
      return this.chatConnection.send(JSON.stringify({
        channel: channelName,
        event: {
          d: {
            // delivered confirmation
            id: id,
            // received message id
            u: u // from user

          },
          t: this.api.getServerTime(),
          u: this.storage.get('userId') || myId
        }
      }));
    }
  }, {
    key: "sendReadConfirmationWS",
    value: function sendReadConfirmationWS(_ref2) {
      var channelName = _ref2.channelName,
          rt = _ref2.message.t,
          myId = _ref2.myId;
      return this.chatConnection.send(JSON.stringify({
        channel: channelName,
        event: {
          rt: rt,
          // time of last read message
          t: this.api.getServerTime(),
          u: this.storage.get('userId') || myId
        }
      }));
    }
  }, {
    key: "getHistoryWS",
    value: function getHistoryWS(channelName, reqParams) {
      var url = "".concat(this.chatApiUrl, "chats-service/v1/chats/").concat(channelName, "/history/");
      return this.api.get(function (res) {
        return res;
      }, url, reqParams);
    }
  }, {
    key: "enrichChat",
    value: function enrichChat(chat) {
      var _this3 = this;

      ['subscribe', 'unsubscribe', 'send', 'sendText', 'sendLocation', 'sendPhoto', 'sendObject', 'sendDeliveryConfirmation', 'sendReadConfirmation', 'getHistory', 'setChannelEncryptionKey', 'deleteChannelEncryptionKey'].forEach(function (fnName) {
        chat[fnName] = function (params) {
          for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            rest[_key - 1] = arguments[_key];
          }

          if (typeof params === 'function') {
            rest = [params].concat(_toConsumableArray(rest));
            params = {};
          }

          return _this3[fnName].apply(_this3, [Object.assign({
            channelName: chat.channelName
          }, params)].concat(_toConsumableArray(rest)));
        };
      });
      return chat;
    }
    /**
    * Returns all initated chats. Closed chats will be deleted after some time.
    * @param {Object} params
    * @param {Number} [params.offset]
    * Specifies how many results to skip for the first returned result
    * @param {Number} [params.limit]
    * Specifies how many results to return
    * @param {Boolean} [params.showExpired]
    * Set true to get expired chats amongst others
    * @param {function} [callback]
    * @return {Promise}
    * @soulsdk soul.chats.getAll
    * @example
    * soul.chats.getAll({
    *  showExpired: true,
    *  offset: 40,
    *  limit: 20,
    * }))
    */

  }, {
    key: "getAll",
    value: function getAll(parameters, callback) {
      var _this4 = this;

      return this.api.get('chats', parameters, callback).then(function (res) {
        return Object.assign(res, {
          chats: res.chats.map(_this4.enrichChat)
        });
      });
    }
    /**
     * Return one chat with ID
     * @param {String} chatId
     * @return {Promise}
     * @soulsdk soul.chats.getAll
     * @example
     * soul.chats.getAll(some_chat_id_str)
     * */

  }, {
    key: "getById",
    value: function getById(chatId) {
      return this.api.get("chats/".concat(chatId));
    }
    /**
    * Edits a chat
    * @param {Object} params
    * @param {String} params.chatId
    * ID of chat to edit
    * @param {String} params.chat.myStatus
    * Current user status regarding this chat. List of possible statuses is defined in your Application Configuration
    * @param {function} [callback]
    * @return {Promise}
    * @soulsdk soul.chats.update
    * @example soul.chats.update({
    *   chatId: '76bfdcca-98de-43cc-8591-c7c6912aae79',
    *   myStatus: 'deleted'
    * })
    */

  }, {
    key: "update",
    value: function update(_ref3, callback) {
      var chatId = _ref3.chatId,
          chat = _ref3.chat;
      return this.api.patch("chats/".concat(chatId), chat, callback);
    }
  }, {
    key: "_prepareMsg",
    value: function _prepareMsg(message) {
      return Object.assign({
        t: this.api.getServerTime(),
        id: uuid(),
        u: this.storage.get('userId')
      }, message);
    }
    /**
    * Send delivery confirmation
    * Optional. Sent in response to received message to tell the original sender
    * that their message was successfully delivered.
    * @param {Object} params
    * @param {String} params.channelName
    * @param {Object} params.message
    * received message
    * @param {function} [callback]
    * @return {Promise}
    * @soulsdk soul.chats.sendDeliveryConfirmation
    */

  }, {
    key: "sendDeliveryConfirmation",
    value: function sendDeliveryConfirmation(_ref4, callback) {
      var channelName = _ref4.channelName,
          _ref4$message = _ref4.message,
          id = _ref4$message.id,
          u = _ref4$message.u;
      return this.send({
        channelName: channelName,
        message: {
          d: {
            // delivered confirmation
            id: id,
            // received message id
            u: u // from user

          },
          t: this.api.getServerTime(),
          u: this.storage.get('userId')
        }
      }, callback);
    }
    /**
    * Send read confirmation
    * @param {Object} params
    * @param {String} params.channelName
    * @param {Object} params.message
    * last received message
    * @param {function} [callback]
    * @return {Promise}
    * @soulsdk soul.chats.sendReadConfirmation
    */

  }, {
    key: "sendReadConfirmation",
    value: function sendReadConfirmation(_ref5, callback) {
      var channelName = _ref5.channelName,
          rt = _ref5.message.t;
      return this.send({
        channelName: channelName,
        message: {
          rt: rt,
          // time of last read message
          t: this.api.getServerTime(),
          u: this.storage.get('userId')
        }
      }, callback);
    }
    /**
    * Send text message
    * @param {Object} params
    * @param {String} params.channelName
    * @param {String} params.text
    * message text
    * @param {function} [callback]
    * @return {Promise}
    * @soulsdk soul.chats.sendText
    */

  }, {
    key: "sendText",
    value: function sendText(_ref6, callback) {
      var channelName = _ref6.channelName,
          m = _ref6.text;
      return this.send({
        channelName: channelName,
        message: this._prepareMsg({
          m: m // message text

        })
      }, callback);
    }
    /**
    * Send location
    * @param {Object} params
    * @param {String} params.channelName
    * @param {String} [params.text]
    * message text
    * @param {Number} params.latitude
    * latitude of the sent coordinates
    * @param {Number} params.longitude
    * longitude of the sent coordinates
    * @param {function} [callback]
    * @return {Promise}
    * @soulsdk soul.chats.sendLocation
    */

  }, {
    key: "sendLocation",
    value: function sendLocation(_ref7, callback) {
      var channelName = _ref7.channelName,
          m = _ref7.text,
          lat = _ref7.latitude,
          lng = _ref7.longitude;
      return this.send({
        channelName: channelName,
        message: this._prepareMsg({
          m: m,
          // message text
          lat: lat,
          // latitude
          lng: lng // longtitude

        })
      }, callback);
    }
    /**
    * Send photo
    * @param {Object} params
    * @param {String} params.channelName
    * @param {String} [params.text]
    * picture caption
    * @param {String} params.photoId
    * id of the photo to send (see).
    * You must upload the photo before sending this message to chat channel.
    * See media.uploadPhoto
    * @param {String} params.albumName
    * album name of the photo to send
    * @param {function} [callback]
    * @return {Promise}
    * @soulsdk soul.chats.sendPhoto
    */

  }, {
    key: "sendPhoto",
    value: function sendPhoto(_ref8, callback) {
      var channelName = _ref8.channelName,
          m = _ref8.text,
          p = _ref8.photoId,
          pa = _ref8.albumName;
      return this.send({
        channelName: channelName,
        message: this._prepareMsg({
          m: m,
          // message text
          p: p,
          // photoId
          pa: pa // albumName

        })
      }, callback);
    }
    /**
    * Send object
    * @param {Object} params
    * @param {String} params.channelName
    * @param {String} [params.text]
    * description
    * @param {Object} params.object
    * arbitrary object
    * @param {function} [callback]
    * @return {Promise}
    * @soulsdk soul.chats.sendObject
    */

  }, {
    key: "sendObject",
    value: function sendObject(_ref9, callback) {
      var channelName = _ref9.channelName,
          m = _ref9.text,
          o = _ref9.object;
      return this.send({
        channelName: channelName,
        message: this._prepareMsg({
          m: m,
          // message text
          o: o // object

        })
      }, callback);
    }
    /**
    * Set channel encryption key
    * @param {Object} params
    * @param {String} params.channelName
    * @param {Object} params.encryptionKey
    * key what will be used for encryption
    * @soulsdk soul.chats.setChannelEncryptionKey
    */

  }, {
    key: "setChannelEncryptionKey",
    value: function setChannelEncryptionKey(_ref10) {
      var channelName = _ref10.channelName,
          encryptionKey = _ref10.encryptionKey;
      this.storage.set(['channelsEncryptionKeys', channelName], encryptionKey);
    }
    /**
    * Delete channel encryption key, thereby disable channel encryption
    * (if global encrypteion key not presented)
    * @param {Object} params
    * @param {String} params.channelName
    * @soulsdk soul.chats.deleteChannelEncryptionKey
    */

  }, {
    key: "deleteChannelEncryptionKey",
    value: function deleteChannelEncryptionKey(_ref11) {
      var channelName = _ref11.channelName;
      this.storage.set(['channelsEncryptionKeys', channelName], null);
    }
    /**
    * Set channel encryption key
    * @param {Object} params
    * @param {Object} params.encryptionKey
    * key what will be used for encryption of channel
    * if specific key wasn't set by setChannelEncryptionKey
    * @soulsdk soul.chats.setGlobalEncryptionKey
    */

  }, {
    key: "setGlobalEncryptionKey",
    value: function setGlobalEncryptionKey(_ref12) {
      var encryptionKey = _ref12.encryptionKey;
      this.storage.set('allChannelsEncryptionKey', encryptionKey);
    }
    /**
    * Delete global encryption key, disable channel encryption
    * if specific key wasn't set by setChannelEncryptionKey
    * @soulsdk soul.chats.deleteGlobalEncryptionKey
    */

  }, {
    key: "deleteGlobalEncryptionKey",
    value: function deleteGlobalEncryptionKey() {
      this.storage.set('allChannelsEncryptionKey', null);
    }
  }, {
    key: "addToContacts",
    value: function addToContacts(userId) {
      return this.api.post('contacts/requests', {
        userId: userId
      });
    }
  }, {
    key: "acceptContactRequest",
    value: function acceptContactRequest(requestId) {
      return this.api.post("contacts/requests/".concat(requestId, "/approve"));
    }
  }, {
    key: "declineContactRequest",
    value: function declineContactRequest(requestId) {
      return this.api.post("contacts/requests/".concat(requestId, "/decline"));
    }
  }, {
    key: "cancelContactRequest",
    value: function cancelContactRequest(requestId) {
      return this.api.post("contacts/requests/".concat(requestId, "/cancel"));
    }
  }, {
    key: "saveContactName",
    value: function saveContactName(userId, nickname) {
      return this.api.patch("contacts/".concat(userId), {
        nickname: nickname
      });
    }
  }, {
    key: "deleteContact",
    value: function deleteContact(userId) {
      return this.api["delete"]("contacts/".concat(userId));
    }
  }, {
    key: "getLastContactRequest",
    value: function getLastContactRequest(chatId) {
      return this.api.get("contacts/requests/last_sent/".concat(chatId));
    }
  }, {
    key: "markChatAsOpened",
    value: function markChatAsOpened(chatId) {
      return this.api.patch("chats/".concat(chatId), {
        myOpen: true
      });
    }
  }, {
    key: "deleteMessage",
    value: function deleteMessage(channelName, messageId, reqParams) {
      var url = "".concat(this.chatApiUrl, "chats-service/v1/chats/").concat(channelName, "/messages/").concat(messageId, "/");
      return this.api["delete"](url, reqParams);
    }
  }, {
    key: "clearHistory",
    value: function clearHistory(channelName, reqParams) {
      var url = "".concat(this.chatApiUrl, "chats-service/v1/chats/").concat(channelName, "/messages/");
      return this.api["delete"](url, reqParams);
    }
  }, {
    key: "getMessagesById",
    value: function getMessagesById(channelName, messageIds) {
      var mainUrl = "".concat(this.chatApiUrl, "chats-service/v1/chats/").concat(channelName, "/messages/");

      if (!messageIds) {
        throw Error('soul.chats.getMessagesById: empty message ids list');
      }

      return this.api.get(function (res) {
        return res;
      }, mainUrl, {
        ids: messageIds.join(',')
      });
    }
  }, {
    key: "getMessageById",
    value: function getMessageById(channelName, messageId) {
      var mainUrl = "".concat(this.chatApiUrl, "chats-service/v1/chats/").concat(channelName, "/messages/").concat(messageId, "/");

      if (!messageId) {
        throw Error('soul.chats.getMessageById: empty message id');
      }

      return this.api.get(function (res) {
        return res;
      }, mainUrl);
    }
  }, {
    key: "getChatCallAnswer",
    value: function getChatCallAnswer() {
      var url = "".concat(this.chatApiUrl, "chats-service/v1/calls-answer/");
      return this.api.get(function (res) {
        return res;
      }, url);
    }
  }, {
    key: "getStickerPacks",
    value: function getStickerPacks(_ref13) {
      var _ref13$lang = _ref13.lang,
          lang = _ref13$lang === void 0 ? 'en' : _ref13$lang;
      var search = queryString.stringify({
        lang: lang
      });
      var url = "".concat(this.chatApiUrl, "chats-service/v1/sticker-packs/?").concat(search);
      return this.api.get(url);
    }
  }, {
    key: "leaveChatWithReason",
    value: function leaveChatWithReason(channelName, reason) {
      var url = "".concat(this.chatApiUrl, "chats-service/v3/chats/").concat(channelName, "/terminate/");
      return this.api.post(url, {
        reason: reason
      });
    }
  }, {
    key: "blockChat",
    value: function blockChat(chatId) {
      var url = "".concat(this.chatApiUrl, "chats-service/v3/chats/").concat(chatId, "/block/");
      return this.api.post(url);
    }
  }, {
    key: "reportChatWithReason",
    value: function reportChatWithReason(chatId, reason) {
      var url = "".concat(this.chatApiUrl, "chats-service/v3/chats/").concat(chatId, "/report/");
      return this.api.post(url, {
        reason: reason
      });
    }
  }, {
    key: "chatApiUrl",
    get: function get() {
      return this.apiUrls.urls.apiEndpoint;
    }
  }, {
    key: "chatWsUrl",
    get: function get() {
      return this.apiUrls.urls.chatWsUrl;
    }
  }]);

  return Chats;
}(SoulModule);

module.exports = Chats;